import React, { Component } from "react";
import glamorous, { Div } from "glamorous";
import Autocomplete from "../../common/AutoComplete";
import { extractLocationData, geocodeByPlaceId } from "../../../common";

const ClearLocation = glamorous.span({
  position: "absolute",
  top: 0,
  right: -16,
  color: "#979797",
  ":hover": {
    cursor: "pointer"
  },
  ":before": {
    content: "x",
    fontFamily: "sans-serif"
  }
});

class SearchLocationInput extends Component {
  constructor(props) {
    super(props);

    let locText =
      `${props.searchFilters.city ? props.searchFilters.city + ", " : ""}` +
      `${props.searchFilters.region ? props.searchFilters.region + ", " : ""}` +
      `${props.searchFilters.country ? props.searchFilters.country : ""}`;
    this.state = {
      width: window.innerWidth,
      locText,
      lastSearch: locText
    };
    this.locationChangeHandler = this.locationChangeHandler.bind(this);
    this.locationSelectHandler = this.locationSelectHandler.bind(this);
    this.locationClearHandler = this.locationClearHandler.bind(this);
    this.renderClearLocation = this.renderClearLocation.bind(this);
  }

  locationSelectHandler(address, placeId) {
    geocodeByPlaceId(placeId)
      .then(results => {
        const place = results[0];
        if (!place) {
          console.error("Error with result Data");
          return;
        }
        // save location
        this.props.saveLocation(place);
        // apply to state
        let placeData = extractLocationData(place);
        let locText =
          `${placeData.city ? placeData.city + ", " : ""}` +
          `${placeData.region ? placeData.region + ", " : ""}` +
          `${placeData.country ? placeData.country : ""}`;
        this.setState({ locText, lastSearch: locText });
      })
      .catch(error => {
        console.error("Issue with Geocoding: ", error);
      });
  }

  locationChangeHandler(value) {
    this.setState({ locText: value });
  }

  locationClearHandler() {
    if (this.state.lastSearch !== "") {
      this.props.saveLocation("");
      this.setState({ locText: "", lastSearch: "" });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.searchFilters.city !== nextProps.searchFilters.city) {
      // reset location text (in main searchbar).
      this.setState({ locText: "" });
    }
  }

  renderClearLocation = () => {
    if (this.state.locText !== "") {
      return <ClearLocation onClick={this.locationClearHandler} />;
    }
  };

  render() {
    const inputProps = {
      value: this.state.locText,
      id: "autocompleteLocation",
      placeholder: "Enter a Location",
      type: "text",
      onChange: this.locationChangeHandler
    };

    const options = {
      types: this.props.filterMembersLivingIn ? ["(cities)"] : ["(regions)"]
    };

    return (
      <Div
        display="inline-block"
        position="relative"
        width={this.props.fullWidth ? "100%" : "inherit"}
      >
        <Autocomplete
          inputProps={inputProps}
          onSelect={this.locationSelectHandler}
          options={options}
          onEnterKeyDown={this.locationClearHandler}
          custom="mt-purple"
          autoResize={this.props.autoResize}
          maxInputLength={this.props.maxInputLength}
          addEllipsis={true}
        />
        {this.renderClearLocation()}
      </Div>
    );
  }
}

export default SearchLocationInput;



// WEBPACK FOOTER //
// ./src/components/pages/Search/SearchLocationInput.jsx